import React from 'react';

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-6 text-slate-800">About&nbsp;Us</h1>

      <p className="text-slate-700 leading-relaxed mb-4">
        <strong>Named&nbsp;By&nbsp;God</strong> is an initiative of the
        <em> International Biblical Onomastic Society</em>, a non-profit research
        community dedicated to the study of names found in the Hebrew Bible, the Greek
        New Testament, and related Second-Temple literature.
      </p>

      <p className="text-slate-700 leading-relaxed mb-4">
        We believe—together with the ancient writers—that a name is far more than a
        label.  In biblical thought, to name something was to exercise stewardship
        over it, to bless it, and to reveal its inner character.  Our database
        preserves the linguistic roots (<em>nuach</em>, <em>shalom</em>, <em>theos-soter</em>
        …), scriptural occurrences, cultural echoes, and modern popularity of more
        than <strong>3,400</strong> distinct names and variants.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4 text-slate-800">
        What we do
      </h2>
      <ul className="list-disc list-inside space-y-2 text-slate-700">
        <li>
          Curate a continually growing corpus of Hebrew, Greek, and Aramaic
          personal names, each annotated with etymology, biblical references, and
          historical commentary.
        </li>
        <li>
          Offer open-access tools—including the live search and autocomplete
          you see on the homepage—to help scholars, pastors, and families explore
          divine naming traditions.
        </li>
        <li>
          Publish peer-reviewed articles and host round-table webinars on
          onomastics, linguistics, and biblical theology.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4 text-slate-800">
        Our vision
      </h2>
      <p className="text-slate-700 leading-relaxed">
        In Isaiah&nbsp;43:1, God says, “<em>I have called you by name; you are
        mine.</em>”  Our hope is that every visitor—whether choosing a name for a
        child, preparing a sermon, or pursuing academic research—will sense the
        beauty and weight carried by these ancient words.
      </p>
    </div>
  );
}
